import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Menu, X, LogOut, LayoutDashboard } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/carte", label: "Carte" },
  { to: "/blog", label: "Blog" },
  { to: "/abonnement", label: "S'abonner" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = React.useState(false);

  return (
    <header className="glass sticky top-0 z-40" data-testid="header">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 py-3">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          {/* Custom text-based logo — legible */}
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center w-11 h-11 rounded-2xl bg-[var(--agt-mustard)] shadow-md">
              <span className="block w-6 h-6 rounded-md bg-[var(--agt-navy)] grid place-items-center text-[var(--agt-mustard)] font-heading text-xs leading-none">A</span>
            </span>
            <div className="leading-[1.05] hidden sm:block">
              <div className="font-heading text-[1.4rem] text-[var(--agt-navy)]">Annuaire</div>
              <div className="text-[0.62rem] tracking-[0.32em] font-black text-[var(--agt-mustard-deep)] uppercase">Grande Taille</div>
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `px-4 py-2 text-base font-bold transition-colors ${
                  isActive ? "text-[var(--agt-mustard-deep)]" : "text-[var(--agt-navy)] hover:text-[var(--agt-mustard-deep)]"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {!user ? (
            <>
              <Link to="/connexion" data-testid="header-login-link" className="text-base font-bold text-[var(--agt-navy)] hover:text-[var(--agt-mustard-deep)]">Connexion</Link>
              <Link to="/inscription" data-testid="header-register-link" className="btn-primary btn-sm">Inscription</Link>
            </>
          ) : (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="header-admin-link" className="btn-ghost btn-sm">
                  <LayoutDashboard className="w-4 h-4" /> Admin
                </Link>
              )}
              <button
                data-testid="header-logout-btn"
                onClick={() => { logout(); nav("/"); }}
                className="btn-ghost btn-sm"
              >
                <LogOut className="w-4 h-4" /> Sortir
              </button>
            </>
          )}
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-btn"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[var(--agt-line)] bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="px-4 py-3 text-lg font-bold hover:bg-[var(--agt-bg-soft)] rounded-2xl"
                data-testid={`mobile-nav-${l.to.replace("/", "") || "home"}`}
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <div className="pt-3 mt-3 border-t border-[var(--agt-line)] flex gap-2">
              {!user ? (
                <>
                  <Link to="/connexion" onClick={() => setOpen(false)} className="btn-ghost btn-sm flex-1 justify-center">Connexion</Link>
                  <Link to="/inscription" onClick={() => setOpen(false)} className="btn-primary btn-sm flex-1 justify-center">Inscription</Link>
                </>
              ) : (
                <button onClick={() => { logout(); nav("/"); setOpen(false); }} className="btn-ghost btn-sm flex-1 justify-center">Déconnexion</button>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
